import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhyFailSection } from '../components/WhyFailSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PricingSection } from '../components/PricingSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream font-sans text-warm-dark selection:bg-terracotta/20" data-id="element-215">
      <Hero data-id="element-216" />
      <ProblemSection data-id="element-217" />
      <SolutionSection data-id="element-218" />
      <WhyFailSection data-id="element-219" />
      <BenefitsSection data-id="element-220" />
      <IncludesSection data-id="element-221" />
      <ForWhomSection data-id="element-222" />
      <PricingSection data-id="element-223" />
      <CTASection data-id="element-224" />
      <Footer data-id="element-225" />
    </main>;
}